export default __webpack_public_path__ + "static/media/WashingtonAnswer.d25c3c2e.png";